/* eslint-disable no-unused-vars */
import { createContext, useState, useEffect } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth"
import { auth, db, functions } from "../firebase"
import { collection, getDocs, query, where } from "firebase/firestore";
import { useCookies } from "react-cookie";
import { getMyAccess } from "../services/venue-services";


export const UserContext = createContext()

export function UserContextProvider(props) {

  const [currentUser, setCurrentUser] = useState();
  const [loadingData, setLoadingData] = useState(true);
  const [currentUserState, setCurrentUserState] = useState(0)
  const [cookie, setCookie, removeCookie] = useCookies(['whatson'], "/");
  const [searchQuery, setSearchQuery] = useState()

  const getAccessForUser = async (user) => {
    const token = await user.getIdToken()
    const response = await getMyAccess(token)
    return { email: user.email, uid: user.uid, ...response.data }
  }

  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    setCurrentUser(user)
    if (!user) {
      setCurrentUserState(0)
      removeCookie("whatson")
      setLoadingData(false)
      return
    }
    getAccessForUser(user)
      .then(access => {
        setCurrentUserState(access.role ?? 0)
        setCookie("whatson", access)
      })
      .catch(() => {
        setCurrentUserState(0)
        removeCookie("whatson")
      })
      .finally(() => setLoadingData(false))
  })
  return unsubscribe
// Subscribe once; the cookie setters are only used inside the callback
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [])


  const getCustomerOrdersBySource = async (source) => {
    var ordersList = []
    const ordersRef = collection(db,"customerOrders")
    const q = await query(ordersRef, where("source", "==", source))
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      var user = { id: doc.id, ...doc.data() }
      ordersList.push(user)
    })
    return ordersList
  }

  const getUserByEmail = async (email) => {
    var usersList = []
    var lowerEmail = email.toLowerCase();
    const userRef = collection(db, "users")
    const q = await query(userRef, where("email", "==", lowerEmail));
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      var user = { id: doc.id, ...doc.data() }
      usersList.push(user)
    })
    return usersList[0]
  }

  const resetPassword = async (email) => {
    await sendPasswordResetEmail(auth, email)
  }

  const initiateSearchQuery = (data) => {
    var stripped = data.replace(" ","")
    console.log(stripped)
    setSearchQuery(stripped)
  }

  // const signUp = async (email, pwd, displayName, role, retailerName, retailerAddressLine1, retailerAddressLine2, retailerTown, retailerCity, retailerPostcode, retailerPhoneNumber) => {
  //   await createUserWithEmailAndPassword(auth, email, pwd).then((res) => {
  //     updateProfile(auth.currentUser, {
  //       displayName: displayName
  //     }).then(() => {
  //       if (role !== "6" && role !== "7") {


  //         var data = {
  //           displayName: displayName,
  //           email: email,
  //           role: role,
  //           uid: auth.currentUser.uid
  //         }
  //       }
  //       else {
  //         data = {
  //           displayName: displayName,
  //           email: email,
  //           role: role,
  //           uid: auth.currentUser.uid,
  //           retailerName: retailerName,
  //           retailerAddressLine1: retailerAddressLine1,
  //           retailerAddressLine2: retailerAddressLine2,
  //           retailerTown: retailerTown,
  //           retailerCity: retailerCity,
  //           retailerPostcode: retailerPostcode,
  //           retailerPhoneNumber: retailerPhoneNumber
  //         }
  //       }
  //       addDoc(collection(db, "users"), data);
  //     })
  //   })
  // }
  const signIn = (email, pwd) => signInWithEmailAndPassword(auth, email, pwd)

  const getUserList = async () => {
    var userList = []
    const querySnapshot = await getDocs(collection(db, "users"));
    querySnapshot.forEach((doc) => {
      var item = { id: doc.id, ...doc.data() }
      userList.push(item)
    });

    return userList
  }

  const getUserByUid = async (id) => {
    var userList = []
    const userRef = collection(db, "users");
    const q = await query(userRef, where("uid", "==", id))
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      var item = { id: doc.id, ...doc.data() }
      userList.push(item)
    });
    return userList
  }

 

  // modal
  const [modalState, setModalState] = useState({
    signUpModal: false,
    signInModal: false
  })

  const toggleModals = modal => {
    if (modal === "signIn") {
      setModalState({
        signUpModal: false,
        signInModal: true
      })
    }
    if (modal === "signUp") {
      setModalState({
        signUpModal: true,
        signInModal: false
      })
    }
    if (modal === "close") {
      setModalState({
        signUpModal: false,
        signInModal: false
      })
    }
  }

  const setCurrentUserRole = (role) => {
    if(typeof(role) == "undefined"){
      setCurrentUserRole(0)
    }
    else{
      setCurrentUserState(role)
    }
  }

  return (
    <UserContext.Provider value={{
      modalState, toggleModals, setCurrentUserRole, currentUserState, currentUser, signIn, getUserList, resetPassword, functions, getUserByUid, getUserByEmail, getAccessForUser, getCustomerOrdersBySource, initiateSearchQuery, searchQuery
    }}>
      {!loadingData && props.children}
    </UserContext.Provider>
  )
}

